import React, { useState, useEffect } from "react";
// import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { addProductImages } from "../../api/productService";
import { getErrorMessage } from "../../utils/errorHandler";

export default function AddProductImages({
  id,
  onSuccess,
  existingImages = [],
  existingFeaturedImage = "",
}) {
  const initialState = {
    featuredImage: null,
    images: [],
  };

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [backendErrors, setBackendErrors] = useState({});
  const [featuredPreview, setFeaturedPreview] = useState("");
  const [galleryPreview, setGalleryPreview] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    if (existingFeaturedImage) {
      setFeaturedPreview(existingFeaturedImage);
    }

    if (existingImages?.length) {
      setGalleryPreview(existingImages);
    }
  }, [existingFeaturedImage, existingImages]);

  // const validationSchema = Yup.object({
  //   featuredImage: Yup.mixed().required("Featured image is required"),
  //   images: Yup.array().max(3, "Maximum 3 gallery images are allowed"),
  // });

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result);

      reader.onerror = (error) => reject(error);
    });
  };

  const handleChange = (e) => {
    const { name, files } = e.target;

    if (name === "featuredImage") {
      setFormData((prev) => ({
        ...prev,
        featuredImage: files[0],
      }));

      setFeaturedPreview(URL.createObjectURL(files[0]));

      setErrors((prev) => ({
        ...prev,
        featuredImage: "",
      }));

      return;
    }
if (name === "images") {
  const selectedFiles = Array.from(files);

  if (selectedFiles.length > 3) {
    setFormData((prev) => ({
      ...prev,
      images: selectedFiles,
    }));

    setErrors((prev) => ({
      ...prev,
      images: "Maximum 3 gallery images are allowed",
    }));

    return;
  }

  setFormData((prev) => ({
    ...prev,
    images: selectedFiles,
  }));

  setErrors((prev) => ({
    ...prev,
    images: "",
  }));
}
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // await validationSchema.validate(formData, {
      //   abortEarly: false,
      // });

      setErrors({});
      setLoading(true);

      let featuredImage = "";

      if (formData.featuredImage) {
        featuredImage = await convertToBase64(formData.featuredImage);
      }

      const images = await Promise.all(
        formData.images.map(async (image) => {
          return await convertToBase64(image);
        }),
      );

      const payload = {
        id,
        featuredImage,
        images,
      };

      const response = await addProductImages(payload);
      setBackendErrors(response.error)
      setSuccessMessage("Product Images Added Successfully");

      setTimeout(() => {
        setSuccessMessage("Product Images Added Successfully");
      }, 1500);

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.log(error);
      alert(getErrorMessage(error));

      if (error.inner) {
        const validationErrors = {};

        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });

        setErrors(validationErrors);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="card shadow border-0">
        {successMessage && (
          <div
            className="alert alert-success position-fixed top-0 end-0 m-3 shadow"
            style={{
              zIndex: 9999,
              minWidth: "300px",
            }}
          >
            {successMessage}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Featured Image
                <span className="error">*</span>
              </label>

              <input
                type="file"
                name="featuredImage"
                className={`form-control ${
                  errors.featuredImage || backendErrors?.featuredImage ? "is-invalid" : ""
                }`}
                accept="image/*"
                onChange={handleChange}
              />

              {errors.featuredImage && (
                <div className="invalid-feedback">{errors.featuredImage}</div>
              )}
              {!errors.featuredImage && backendErrors?.featuredImage && (
              <div className="invalid-feedback d-block">
                {backendErrors.featuredImage}
              </div>
            )}
            </div>

            <div className="col-md-6">
              {featuredPreview && (
                <div className="mt-3">
                  <img
                    src={featuredPreview}
                    alt="featured"
                    width="120"
                    height="120"
                    style={{
                      objectFit: "cover",
                      borderRadius: "10px",
                      border: "1px solid #ddd",
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 mb-3">
              <label className="form-label">Upload Gallery Images</label>

              <input
                type="file"
                name="images"
                className={`form-control ${
                  errors.featuredImage ? "is-invalid" : ""
                }`}
                multiple
                accept="image/*"
                onChange={handleChange}
              />
              {errors.images && (
                <div className="invalid-feedback">{errors.images}</div>
              )}
            </div>
          </div>

          <div className="row mt-3">
            {galleryPreview.map((img, index) => (
              <div className="col-md-2 mb-2" key={index}>
                <img
                  src={img}
                  alt={`gallery-${index}`}
                  className="img-fluid border rounded"
                  style={{
                    height: "100px",
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            ))}
          </div>

          <div className="col-md-12 d-flex justify-content-end gap-2">
            <button type="submit" className="btn btn-primary mt-3">
              {loading ? "Submitting..." : "Submit"}
            </button>

            <button
              type="button"
              className="btn btn-secondary mt-3"
              onClick={() => {
                setFormData(initialState);
                setErrors({});
                navigate("/products");
              }}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
